<template>
  <div class="app" v-if="!isMobile">
    <Header />
    <Fixbar />
    <transition name="fade">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header/index'
import Fixbar from './components/FixBar/index'
import Footer from './components/Footer/index'
import { isMobile } from './util'
export default {
  name: 'App',
  components: {
    Header,
    Fixbar,
    Footer,
  },
  data() {
    return {
      isMobile: isMobile(),
    }
  },
}
</script>
